var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"promos-header__logo",class:_vm.getClass,attrs:{"href":"/"}},[_c('img',{attrs:{"src":_vm.getLogoImage}})])}
var staticRenderFns = []

export { render, staticRenderFns }